<template>
  <div class="my-pooq-view-wrapper">
    <div v-if="device === 'mobile'" :class="hearderClass">
      <common-header
        title="이벤트"
        :back-fn="close"
        :is-back-btn="true"
        :is-close-btn="true"
        :close-fn="close"
      ></common-header>
      <event-main-menu
        :menu-items="menuItems"
        :menu-index="mainMenuIndex"
        :change-menu-fn="changeMainMenu"
      />
    </div>
    <!-- 이용내역 서브 메뉴 -->
    <div class="my-wrap my-sub-wrap my-sub-nav" data-scroll-element="true">
      <router-view key="evnet_list" name="eventlist"></router-view>
      <router-view key="event_board_list" name="boardlist"></router-view>
      <router-view key="event_detail_view" name="eventdetail"></router-view>
      <router-view
        key="event_board_detail_view"
        name="boarddetail"
      ></router-view>
    </div>
  </div>
</template>

<script>
  import EventMainMenu from '@/components/lnb/event/EventMainMenu'
  import { EVENT_MENU_LIST } from '@/common/menu.constant'
  import { mapGetters } from 'vuex'
  import utils from '@/common/util/utils'
  import CommonHeader from '@/components/header/template/commonHeader'

  export default {
    name: 'EventView',
    components: {
      CommonHeader,
      EventMainMenu,
    },
    data() {
      return {
        mainMenuIndex: 0,
        menuItems: EVENT_MENU_LIST,
        device: utils.cookies.getDevice(),
        hearderClass: 'sticky-area',
        lastPath: 'list',
      }
    },
    computed: {
      ...mapGetters(['getBeforePathOpenMyPooq']),
    },
    watch: {
      $route() {
        this.$nextTick(() => {
          const lastPath = this.$route.name
          this.lastPath = lastPath
          this.hearderClass =
            lastPath === 'event_detail' || lastPath === 'board_detail_view'
              ? 'sticky-area displayNone'
              : 'sticky-area'
        })
      },
    },
    created() {
      const lastPath = this.$route.name
      this.lastPath = lastPath
      if (lastPath === 'event') {
        this.$router.replace('/event/list')
      }
      switch (lastPath) {
        case 'list':
          this.mainMenuIndex = 0
          break
        case 'board_list':
          this.mainMenuIndex = 1
          break
      }
      this.$nextTick(() => {
        this.hearderClass =
          this.lastPath === 'event_detail' ||
          this.lastPath === 'board_detail_view'
            ? 'sticky-area displayNone'
            : 'sticky-area'
      })
    },
    methods: {
      close() {
        this.$router.replace(this.getBeforePathOpenMyPooq)
      },
      changeMainMenu(mainMenuObject) {
        this.mainMenuIndex = mainMenuObject.index
        this.$router.push(mainMenuObject.path)
      },
    },
  }
</script>

<style scoped>
  .my-pooq-content-body {
    position: relative;
    width: 100%;
    /*overflow-y:scroll;*/
    /*overflow-scrolling: touch;*/
    /*-webkit-overflow-scrolling: touch;*/
  }
  .displayNone + .my-wrap {
    /*padding-top: 56px;*/
    padding-top: 0;
  }
</style>
